const routes = {
    login: "/",
    register: "/register",
    verifyOtp: "/verify-otp",
    forgotPassword: "/forgot-password",
    resetPasswordConfirm:"/reset-password-confirm",
    completeProfile: "/complete-profile",
    dashboard: "/dashboard",
    recruits: "/recruits",
    commissions: "/commission-history",
    settings: "/profile-settings",
    notifications:"/notifications",
    support: "/support",
    supportTickets: "/support/tickets",
    supportHelp: "/support/help",
    analytics: "/analytics",
};

export default routes;